import { ComponentPropsWithoutRef, forwardRef } from 'react';

import {
  RiArrowUpSLine as ExpandLess,
  RiArrowDownSLine as ExpandMore,
} from '@remixicon/react';

import { ButtonIcon } from '@spotify-internal/encore-web';

import { useSectionContext } from './SectionContext';

export type SectionExpandButtonProps = Omit<
  ComponentPropsWithoutRef<typeof ButtonIcon>,
  'aria-label' | 'children' | 'onClick' | 'variant'
>;

const SectionExpandButton = forwardRef<
  HTMLButtonElement,
  SectionExpandButtonProps
>(({ size = 'small', ...props }, ref) => {
  const { expanded, onToggle } = useSectionContext();

  return (
    <ButtonIcon
      ref={ref}
      variant="tertiary"
      size={size}
      onClick={onToggle}
      aria-label={expanded ? 'Collapse section' : 'Expand section'}
      data-track-id="button.expand-section"
      data-track-action={expanded ? 'collapse' : 'expand'}
      {...props}
    >
      {expanded ? <ExpandLess aria-hidden /> : <ExpandMore aria-hidden />}
    </ButtonIcon>
  );
});

SectionExpandButton.displayName = 'Section.ExpandButton';

export default SectionExpandButton;
